var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Dialog from '@material-ui/core/Dialog';
import classNames from 'classnames';
import React from 'react';
import { DialogSidebar, SidePanelSizes } from './DialogSidebar';
import styles from './StyledDialog.module.css';
var StyledDialogCore = /** @class */ (function (_super) {
    __extends(StyledDialogCore, _super);
    function StyledDialogCore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sidebarCollapsed: window.innerWidth < 1279
        };
        _this.toggleSidebar = function () {
            _this.setState({
                sidebarCollapsed: !_this.state.sidebarCollapsed
            });
        };
        _this.handleDialogBodyClick = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    StyledDialogCore.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, size = _d.size, modal = _d.modal, fullHeight = _d.fullHeight, open = _d.open, onRequestClose = _d.onRequestClose, sidebarRender = _d.sidebarRender, titleComponent = _d.titleComponent, contentComponent = _d.contentComponent, actionsComponent = _d.actionsComponent, alertContent = _d.alertContent, children = _d.children, testId = _d.testId, preventSideBarCollapse = _d.preventSideBarCollapse, sidePanelSize = _d.sidePanelSize, otherProps = __rest(_d, ["size", "modal", "fullHeight", "open", "onRequestClose", "sidebarRender", "titleComponent", "contentComponent", "actionsComponent", "alertContent", "children", "testId", "preventSideBarCollapse", "sidePanelSize"]);
        var dialogBodyStyles = classNames(styles.dialogBody, (_a = {},
            _a[styles.extraSmall] = size === 'xs' || size === 'xxs' || size === 'xxxs',
            _a[styles.extraSmallShort] = size === 'xxxs',
            _a[styles.small] = size === 'sm',
            _a[styles.medium] = size === 'md',
            _a[styles.large] = size === 'lg',
            _a));
        var sideBarOpen = !!preventSideBarCollapse ? true : !!sidebarRender && !this.state.sidebarCollapsed;
        var mainAreaStyles = classNames(styles.mainArea, (_b = {},
            _b[styles.sideBarLockedOpen] = !!preventSideBarCollapse,
            _b[styles.hasSideBar] = !!sidebarRender,
            _b[styles.sideBarOpen] = sideBarOpen,
            _b[styles.sideBarSmallOpen] = sidePanelSize === SidePanelSizes.Small,
            _b));
        var paperStyles = classNames(styles.dialogPaper, (_c = {},
            _c[styles.fullHeight] = fullHeight,
            _c[styles.extraExtraSmallWidth] = size === 'xxs' || size === 'xxxs',
            _c[styles.large] = size === 'lg',
            _c));
        var maxWidth = size === 'xxs' || size === 'xxxs' ? 'xs' : size;
        return (React.createElement(Dialog, __assign({}, otherProps, { "data-test-id": "dialog_" + testId, classes: {
                paper: paperStyles,
                paperWidthXs: styles.extraSmallWidth,
                paperWidthSm: styles.smallWidth,
                paperWidthMd: styles.mediumWidth,
                paperFullScreen: styles.largeWidth
            }, fullWidth: true, maxWidth: maxWidth, onClick: this.handleDialogBodyClick, disableBackdropClick: modal, open: open, onExited: this.props.onExited, onClose: onRequestClose }),
            titleComponent,
            React.createElement("div", { className: dialogBodyStyles },
                sidebarRender && (React.createElement(DialogSidebar, { preventSideBarCollapse: preventSideBarCollapse, sidePanelSize: sidePanelSize, collapsed: this.state.sidebarCollapsed, onToggle: this.toggleSidebar, sidebarRender: sidebarRender })),
                React.createElement("div", { className: mainAreaStyles },
                    alertContent,
                    contentComponent,
                    actionsComponent,
                    children))));
    };
    StyledDialogCore.muiName = 'Dialog';
    return StyledDialogCore;
}(React.Component));
export { StyledDialogCore };
